if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
    }

    connectedCallback() {
      const mode = this.dataset.mode || "slider";
      const enableSlider = this.dataset.enableSlider === "true";

      if (mode !== "slider" || !enableSlider) return;

      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed =
        parseInt(this.dataset.autoplaySpeed, 10) || 3;

      const slideContainer = this.querySelector(".swiper-container");

      if (!slideContainer || typeof MinimogLibs === "undefined") {
        return;
      }

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,

        autoplay: autoplay
          ? {
              delay: autoplaySpeed * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,

        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
      });
    }

    disconnectedCallback() {
      if (
        this.slider &&
        typeof this.slider.destroy === "function"
      ) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }
  }

  customElements.define(
    "m-announcement-bar",
    MAnnouncementBar
  );
}